import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class MotivosTarde extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'motivo-tarde/one', saveUrl: 'motivo-tarde/save', backUrl: '/Catalogo/MotivosTarde' },
      new Form([
        Form.Field('text', 'motivo_clave', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'motivo_nombre', 'Descripcion', '', [Validators.required], 8),
      ], ['Guardar'], 'Motivo De Rechazo'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(MotivosTarde)
